<template>
  <div class="item-container">
    {{ soc.suborder }}
    <el-tag v-if="soc.locality"
            class="locality-tag"
            size="mini"
            effect="dark"> {{ soc.locality }}</el-tag>
    <el-button class="delete-soc" type="text" icon="fas fa-times" @click="selfDestruct"/>
    <span v-if="nonRouteable">
      <!-- No Ruteable -->
      <el-tooltip class="item" effect="dark" content="No encontrado" placement="top-start">
        <span v-if="notFound" class="fa-stack fa-2x non-clickeable">
          <i class="fas fa-cube fa-stack-2x point-package"></i>
          <i class="fas fa-slash fa-stack-2x" style="color: #E6A23C"></i>
        </span>
      </el-tooltip>
    </span>
    <span v-else>
      <!-- Ruteable -->
      <el-tag class="req-at" :type="reqType" size="mini">{{ soc.requested_at | splited }}</el-tag>
      <span v-if="soc.geostate === 4" class="fa-stack fa-2x clickeable" @click="geocode">
        <i class="fas fa-map-marked-alt fa-stack-2x"></i>
        <i class="fas fa-map-marker-alt fa-stack-1x point-map"></i>
      </span>
    </span>
  </div>
</template>

<script>
import moment from 'moment';
import { geoUpdateHandler, manageSession } from '../../../../mixins/manageSession';

export default {
  name: 'VerifiedSoc',
  props: {
    soc: {
      type: Object,
      default() {
        return {
          dp_id: 0,
          geostate: 0,
          last_state: -1,
          last_state_name: 'Desconocido',
          package_type_id: -1,
          package_type_name: 'Desconocido',
          requested_at: '0001-01-01T00:00:00Z',
          locality: 'Desconocido',
          suborder: 0,
        };
      },
    },
  },
  computed: {
    notFound() {
      return this.soc.last_state === 6 || this.soc.dp_id === 0;
    },
    nonRouteable() {
      // TODO: mixin con las constantes
      return this.soc.dp_id === 0 || this.soc.last_state === 5 || this.soc.last_state === 6;
    },
    reqType() {
      // TODO: mixin con esta transformacion, fechas en español
      // eslint-disable-next-line no-nested-ternary
      return this.reqAfter() ? 'warning' : this.reqBefore() ? 'info' : 'success';
    },
  },
  methods: {
    // TODO: poner en un mixin
    linkBlank(sub) {
      const routeData = this.$router.resolve({ name: 'Geocode', query: { v: 'fromSubs' } });
      sessionStorage.setItem('suborders', JSON.stringify([sub]));
      manageSession();
      window.name = 'geosortMain';
      this.newPage = window.open(routeData.href, 'geocode');
    },
    geocode() {
      this.linkBlank(this.soc.suborder);
    },
    selfDestruct() {
      this.$emit('remove', this.soc.suborder);
    },
    reqAfter() {
      const req = this.soc.requested_at;
      const today = moment();
      today.set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      });
      const date = moment(req.split('T')[0]);
      if (date > today) {
        return true;
      }
      return false;
    },
    reqBefore() {
      const req = this.soc.requested_at;
      const today = moment();
      today.set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      });
      const date = moment(req.split('T')[0]);
      if (date < today) {
        return true;
      }
      return false;
    },
  },
  created() {
    // listen for changes to localStorage
    const self = this;
    if (window.addEventListener) {
      window.addEventListener('storage', geoUpdateHandler(
        (code) => {
          const indx = self.list.findIndex(val => val.suborder === code);
          self.list[indx].geostate = 6;
          self.newPage.close();
        },
      ), false);
    }
  },
  filters: {
    splited(date) {
      return moment(date.split('T')[0]).format('D MMM');
    },
  },
};
</script>

<style lang="scss"  scoped>
  .delete-soc {
    float: right;
    padding: 7px 0 3px 8px;
    color: #9B9B9B;
    :hover {
      color: orangered;
    }
  }
  .locality-tag{
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-left: 10px;
    font-weight: bold;
    max-width: calc(100% - 14ch - 110px);
  }
  .socContent {
    display: inline-block;
    width: calc(100% - 20px);
  }

  .fa-stack {
    font-size: 0.6em;
    margin-top: 3px;
    padding-bottom: 2px;
  }
  i { vertical-align: middle; }
  .req-at{
    float: right;
    margin: 5px 4px 0 6px;
  }
  .non-clickeable {
    font-size: 7px;
    padding-top: 3px;
    margin-right: 3px;
    float: right;
    color: darkgray;
  }
  .clickeable {
    font-size: 7px;
    padding-top: 3px;
    margin-right: 3px;
    float: right;
    color: darkgray;
    cursor: pointer;
    animation: jumps .5s infinite;
    :hover {
      color: #AAD500;
      animation: none;
    }
  }
  @keyframes jumps {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(4px);
    }
    100% {
      transform: translateY(0px);
    }
  }
  .point-package {
    color: darkgray;
  }
  .point-map {
    color: #E6A23C;
    font-size: 8px;
    top: -0.5px;
  }
</style>
